import { useParams } from 'react-router-dom'

export const useTaskIdParam = (): string => {
  const params: any = useParams()
  return params?._id ?? undefined
}
